// extracted by mini-css-extract-plugin
export default {"redaction":"qaM37RaV","mobile":"mobile","editor":"yvt7Dsc3","content":"Ktzxjh9r","jobTitle":"VU9XCSTj","email":"RbbxJLgg"};